import { render, staticRenderFns } from "./DownloadIcon.vue?vue&type=template&id=e3ce45b4"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3ce45b4')) {
      api.createRecord('e3ce45b4', component.options)
    } else {
      api.reload('e3ce45b4', component.options)
    }
    module.hot.accept("./DownloadIcon.vue?vue&type=template&id=e3ce45b4", function () {
      api.rerender('e3ce45b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/DownloadIcon.vue"
export default component.exports